<div class="border" [ngClass]="{'show-icon': showIcon, 'no-icon': !showIcon}">
    <div class="info-text">
        <xm-media-image class="image" [staticImagePath]="imagePath" [imageSource]="'buy_static_base_url'" [staticImageAlt]="imageAlt"></xm-media-image>
        <div class="message-button-container">
            <cms-text class="message" [isLink]="true" [originalText]="statusMessage" (onButtonClick)="statusMessageCta()"></cms-text>
        </div>
    </div>
</div>